export default __webpack_public_path__ + "static/char-s-01-jp-f346febf0332c8ea5bfafa4553e8d8c3.webp";